import { useLang } from "../i18n";

export default function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-toggle"
      className="flex items-center rounded-full border border-white/15 bg-black/40 p-1"
    >
      {["en", "de"].map((l) => (
        <button
          key={l}
          data-testid={`lang-toggle-${l}`}
          onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide transition-colors ${
            lang === l ? "bg-gold text-black" : "text-white/60 hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
